import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../../contexts";
import {input} from "../../../utils/linker";
import ContextButton from "../../Helpers/ContextButton";
import LinksUploader from "./LinksUploader";
import humanFileSize from "../../../utils/humanFileSize";

function FileBig(props) {
  const store = useLocalObservable(() => ({
    show_links_uploader:false
  }));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const selectedCount=()=>{
    const selected=compStore.getSelected();
    return selected.length;
  };
  const getValue=(skipCur)=>{
    const selected=compStore.getSelected();
    if(selected.length) {
      if(skipCur) {
        return selected[0];
      } else {
        return compStore.getCur(selected[0]);
      }
    }
    return false;
  };
  const getFile=()=>{
    return getValue().tmp_file || getValue();
  };
  const getSrc=()=>{
    const val=getValue();
    return val.tmp_file ? val.tmp_file.preview_big : val.preview_big;
  };
  const getSrcSource=()=> {
    const val = getValue();
    return val.tmp_file ? val.tmp_file.public_url : val.src;
  }
  const moveToPrev=()=>{
    const found=compStore.findFileById(getValue().sys_uid);
    let newIndex = found.index-1;
    if(newIndex<0) {
      newIndex=compStore.data.length-1;
    }
    runInAction(()=>{
      compStore.clearSelection();
      compStore.selectItem(compStore.data[newIndex]);
    });
  };
  const moveToNext=()=> {
    const found = compStore.findFileById(getValue().sys_uid);
    let newIndex = found.index + 1;
    if (newIndex > (compStore.data.length-1)) {
      newIndex = 0;
    }
    runInAction(() => {
      compStore.clearSelection();
      compStore.selectItem(compStore.data[newIndex]);
    });
  };

  const width=getValue().tmp_file?getValue().tmp_file.width:getValue().width;
  const height=getValue().tmp_file?getValue().tmp_file.height:getValue().height;

  return (
    <div className="h100 pr">
      {getValue()?(
        <div className={`pr ${selectedCount()>1?"transp50":""}`}>
          <div className="pr">
            {getSrc()?(
              <img src={getSrc()} className="w100 of-scale-down db" style={{ height:245 }} />
            ):(
              <div style={{height:245}} className="ptop25">
                <div className=" b1 fs12 lh14 tac ptop20 ofh ttu bold center mtop10 pr " style={{backgroundColor: getFile().color, height:60*3, width: 45*3}}>
                  <div className="pa pa-tr bg-w2" style={{borderColor:`#F8F8F8 #F8F8F8 #ffffff #ffffff`, borderWidth:10*3, borderStyle:"solid"}}></div>
                  <div style={{fontSize:`${12*4}px`}} className="pa lh12 pa-bl  bold w1 pleft5 pbottom2">{getFile().ext}</div>
                </div>
              </div>
            )}
            <div className="pa pa-tl h100 w100 hpadd20 z3 no-event">
              <div className="up12 splice h100">
                <div className="cell s-shrink s-middle rad200 bg-w3 padd10 pointer yes-event noselect" style={{lineHeight:'1em'}} onClick={()=>{ moveToPrev(); }}>
                  <span className="mdi mdi-chevron-left fs24 lh10 db" ></span>
                </div>
                <div className="cell s-shrink s-auto s-middle"></div>
                <div className="cell s-shrink s-middle rad200 bg-w3 padd10 pointer yes-event noselect" style={{lineHeight:'1em'}} onClick={()=>{ moveToNext(); }}>
                  <span className="mdi mdi-chevron-right fs24 lh10 db"></span>
                </div>
              </div>
            </div>
          </div>

          <div className="ptop10 tac">
            <span className="buttonsCombo pr">
              <span className="btn9" onClick={props.openDialog}><span><span className="mdi mdi-upload"></span> Заменить</span></span>
              <ContextButton items={[
                  {title:"Загрузить по ссылке", onClick:()=>{ store.show_links_uploader=true; }},
                  {title:"Удалить", onClick:()=>{ getValue(true).delete=1; compStore.setMarkFileWas(); }},
                ]}>{(ret)=>{
                  return (
                    <span className="btn9 iconOnly pr">
                      <span {...ret.buttonProps}><span className="mdi mdi-dots-vertical"></span></span>
                      {ret.Context}
                    </span>
                  )
                }}
              </ContextButton>
              {store.show_links_uploader?(
                <div className="pa pa-tl bg-w1 padd5 shadow z4">
                  <LinksUploader replace={true} single={true} onClose={()=>{ runInAction(()=>{ store.show_links_uploader=false; }); }} />
                </div>
              ):null}
            </span>
          </div>
          <div className="ptop10 hpadd15">
            <div className="up12 margin">
              <div className="cell s-auto" style={{wordBreak:"break-word"}}>
                <a target="_blank" href={getSrcSource()} className="clear b1 tdni">{getValue().tmp_file?getValue().tmp_file.file_name:getValue().file_name} <span className="mdi mdi-open-in-new fs18 dib vam pc1"></span></a>
              </div>
              <div className="cell s-shrink wsnw">
                <span className="w5">{humanFileSize(getValue().tmp_file?getValue().tmp_file.file_size:getValue().file_size)}</span>
                {width + height > 0?(
                  <span className="w5 pleft10">{width}&times;{height}</span>
                ):null}
              </div>
            </div>
          </div>
          <div className="hpadd15">
            <div className="ptop10">
              <div className="w5 pbottom5">
                Описание
              </div>
              <textarea {...input(getValue(), 'description')} className="w100" style={{height:60,maxWidth:'100%', maxHeight:60, minWidth:'100%'}} />
            </div>
          </div>
          {getValue(true).delete?(
            <div className="pa pa-tl w100 h100 bg-w1-op20 up12 splice z2">
              <div className="cell s-12 tac s-middle">
                <span className="const1">Фото будет удалено при сохранении</span>
                <div className="ptop20">
                  <span onClick={()=>{
                    runInAction(()=>{
                      delete getValue(true).delete;
                    });
                  }} className="btn9 tac pr z4"><span><span className="mdi mdi-delete-restore "></span> Отменить удаление</span></span>
                </div>
              </div>
            </div>
          ):null}
          {selectedCount()>1?(
            <div className="pa pa-tl w100 h100"></div>
          ):null}
        </div>
      ):(
        <div className="h100 up12 splice">
          <div className="cell s-12 tac s-middle fs14">
            <div className="pbottom20">Изображение не выбрано</div>
            <div className="pbottom20">Выберите изображение в правой части экрана. Для выбора нескольких изображений используйте клавитши Ctrl и Shift.</div>
          </div>
        </div>
      )}

    </div>
  )
};

FileBig.defaultProps = {};

FileBig.propTypes = {}

export default observer(FileBig);
